import { useState } from "react"
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "../ui/table"
import { Button } from "../ui/button"

const Table2 = ({ columns = [], data = [], rowsPerPage = 10 , headerBg="bg-gradient-to-r from-indigo-600 to-blue-600 text-white" ,headerText="text-white" }) => {
   
    return (
        <>
            <div className="overflow-x-auto mt-4 rounded-t-2xl">
                <Table>
                    <TableHeader>
                        <TableRow className={headerBg}>
                            {columns.map((col) => (
                               <TableHead className={`${headerText} text-left text-nowrap py-2 pl-4`}

                                key={col.key}>
                                    {col.label}
                                </TableHead>
                            ))}
                        </TableRow>
                    </TableHeader>

                    <TableBody>
                        {data.length > 0 ? (
                            data.map((row, index) => (
                                <TableRow
                                    key={index}
                                    className="hover:bg-muted/50 border-b"
                                >
                                    {columns.map((col) => (
                                        <TableCell key={col.key} >
                                            {col.render
                                                ? col.render(row, index)
                                                : row[col.key]}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell
                                    colSpan={columns.length}
                                    className="text-center py-6 text-muted-foreground"
                                >
                                    No data found
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>

            

        </>
    )
}


export default Table2;